import { AnyAction } from 'redux';
import { LayoutConstants } from './constants';

export interface ILayoutState {
  authoriseAccounts: boolean;
  accountDetails: boolean;
  passwordModal: boolean;
  addNewScopeModal: boolean;
  editPlanModal: boolean;
  imagePreviewModal: { isOpen: boolean; src: string };
}

export interface ILayoutAction extends AnyAction {
  type: LayoutConstants;
}

const initialState: ILayoutState = {
  authoriseAccounts: false,
  accountDetails: false,
  passwordModal: false,
  addNewScopeModal: false,
  editPlanModal: false,
  imagePreviewModal: { isOpen: false, src: '' },
};

const layoutReducer = (state = initialState, action: ILayoutAction): ILayoutState => {
  const { type, payload } = action;
  switch (type) {
    case LayoutConstants.LAYOUT_TOGGLE_AUTHORISE_ACCOUNTS: {
      return { ...state, authoriseAccounts: payload };
    }
    case LayoutConstants.LAYOUT_TOGGLE_ACCOUNT_DETAILS: {
      return { ...state, accountDetails: payload };
    }
    case LayoutConstants.LAYOUT_TOGGLE_PASSWORD: {
      return { ...state, passwordModal: payload };
    }
    case LayoutConstants.LAYOUT_TOGGLE_IMAGE_PREVIEW: {
      return { ...state, imagePreviewModal: payload };
    }
    case LayoutConstants.LAYOUT_TOGGLE_ADD_NEW_SCOPE: {
      return { ...state, addNewScopeModal: payload };
    }
    case LayoutConstants.LAYOUT_TOGGLE_EDIT_PLAN: {
      return { ...state, editPlanModal: payload };
    }
    default:
      return state;
  }
};

export default layoutReducer;
